import { Component, Input } from '@angular/core';
import { FooterService } from '../../_services/footer.service';
import { VERSION } from '../../../environments/version';
import { CommonModule } from '@angular/common';

@Component( {
    selector: 'app-footer',
    standalone: true,
    styleUrls: ['./app-footer.component.scss'],
    templateUrl: './app-footer.component.html',
    imports: [CommonModule]
})
export class AppFooterComponent {
    public footer = {
      left_part:"DocsIA",
      right_part:VERSION.tag,
    };

    constructor( private footerServ: FooterService) {
      this.footerServ.getCurrent().subscribe((footer: any) => this.footer = footer);
    }
}
